import React, { Component } from 'react';
import { Select } from 'vivace-fluent-motion';

class SelectComponent extends Component {
  constructor () {
    super();
    this.selectRef = React.createRef();
  }

  render () {
    var props = { ...this.props };
    if (this.props.selectRef !== undefined) {
      this.selectRef = this.props.selectRef;
      delete props.selectRef;
    }
    if (this.props.ref !== undefined) {
      this.selectRef = this.props.ref;
      delete props.ref;
    }

    return (
      <Select
        // options={
        //   props.options && props.options.length > 0
        //     ? getOptions(props.options)
        //     : ''
        // }
        isClearable={props.isClearable? props.isClearable : false}
        classNamePrefix={`mv-vivace-fluent-motion-select${
          this.props.isMulti ? '-multi' : ''
        }`}
        height={38}
        innerRef={props.innerRef}
        {...props}
        isDisabled={props.disabled}
        placeholder={props.placeholder}
      />
    );
    //<p onClick={() => props.onRemove(props.value)} className="close">X</p>
  }
  focus() {
    this.selectRef && this.selectRef.current.focus();
  }
}

export default SelectComponent;



// WEBPACK FOOTER //
// ./src/componentes/select/select.component.js